/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportScheduleSummary {
    getFixupPrototypeFunction() { return ReportScheduleSummary.fixupPrototype; }

    static newInstance(model: Partial<ReportScheduleSummary>): ReportScheduleSummary {
        let obj = Object.assign(new ReportScheduleSummary(), model);
        ReportScheduleSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportScheduleSummary>): ReportScheduleSummary {
        if (!model) return null;
        return ReportScheduleSummary.newInstance(<ReportScheduleSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportScheduleSummary) {
        if (!obj) return;

        models.ReportScheduleSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportScheduleSummary): boolean {
        Object.setPrototypeOf(obj, ReportScheduleSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_time === "string") {
            this.start_time = new Date(<string><any>this.start_time);
        }
    }

    /**
     * Unique id of the schedule
     */
    id: string;

    /**
     * Name given to the schedule
     */
    name: string;

    /**
     * Name of the scheduled report
     */
    report_name: string;

    /**
     * Human-readable summary of when the schedule runs
     */
    description: string;

    /**
     * Date and time of the first run
     */
    start_time: Date;

    /**
     * Outcome of the most recent run, as reported by the report server
     */
    last_status: string;

    /**
     * Tenants the report is filtered to
     */
    tenants: Array<string>;

    /**
     * Cloud accounts the report is filtered to
     */
    cloud_accounts: Array<string>;

}
